module.exports = __webpack_public_path__ + "img/hyj7.4350742c.png";